import React, { Component } from 'react'
import { compose } from 'recompose'
import WithAjax from '../../common/helpers/WithAjax'
import WithNotify from '../../common/helpers/WithNotify'
import Table from '../../../tables/reactable/DefaultTable'
import EditClientAccountPopup from '../actions/AcceptEditClientAccountPopup'
import RemoveClientAccount from '../actions/RemoveClientAccount'

class ClientAccountList extends Component {
  constructor() {
    super()
    this.onChangeItemsPerPage = this.onChangeItemsPerPage.bind(this)
    this.onSearch = this.onSearch.bind(this)
    this.state = {
      itemsPerPage: 10,
      search: ''
    }
    this.columns = [
      'ProductionContentOwnerName',
      'ClientForSearch',
      'FullName',
      'JobTitle',
      'Email',
      'EmailForSearch',
      'Countries',
      'CountriesForSearch',
      'StatusModifiedDate',
	    'Actions'
    ]
    this.columnNames = [
      'Client',
      'ClientForSearch',
      'Full name',
      'Job title',
      'Email',
      'EmailForSearch',
      'Countries',
      'CountriesForSearch',
      'Status modified date',
	    'Actions'
    ]
  }

  onChangeItemsPerPage(e) {
    e.preventDefault()
    this.setState({
      itemsPerPage: e.target.value
    })
    return false
  }

  onSearch(e) {
    e.preventDefault()
    this.setState({
      search: e.target.value
    })
    return false
  }

  render() {
    let items = this.props.items.map(item => {
      item.Countries.forEach(function(country, index){
        item.Countries[index] = country.toUpperCase();
      });
      return Object.assign({}, item, {
      	ProductionContentOwnerName: item.ProductionContentOwnerIconUrl ? (<img src={item.ProductionContentOwnerIconUrl} style={{width: '50px'}} alt="" />) : (null),
        ClientForSearch: item.ProductionContentOwnerName,
        Email: (<a href={'mailto:' + item.Email}>{item.Email}</a>),
        EmailForSearch: item.Email,
        StatusModifiedDate: item.StatusModifiedDateAsString,
        Countries: item.Countries.join(", "),
        CountriesForSearch: item.Countries,
        Actions: (
          <span>
              <EditClientAccountPopup accountId={item.Id} onReload={this.props.onReload} mode="edit"/>
              <RemoveClientAccount accountId={item.Id} onReload={this.props.onReload} mode="edit" />
          </span>)
          })
    });

    return (
      <div>
        <Table
          items={items}
          columns={this.columns}
          columnNames={this.columnNames}
          itemsPerPage={this.state.itemsPerPage}
          hiddenColumns={[
            'EmailForSearch',
            'ClientForSearch',
            'CountriesForSearch'
          ]}
          searchable={[
            'FullName',
            'JobTitle',
            'Email',
            'Countries',
            'Client',
            'EmailForSearch',
            'ClientForSearch',
            'CountriesForSearch'
          ]}
          search={this.state.search}
          onSearch={this.onSearch}
          onChangeItemsPerPage={this.onChangeItemsPerPage}
          openBtnVisible={false}
          sortable={[
            'ProductionContentOwnerName',
            'FullName',
            'JobTitle',
            'Email',
            'StatusModifiedDate'
          ]}
          defaultSort={{column: 'FullName', direction: 'asc'}}
        />
      </div>
    )
  }
}

export default compose(WithAjax, WithNotify)(ClientAccountList)
